export default {
    basicInfo: '/basic/home/statistics',
    data: '/basic/home/data',
    getMoremes: '/basic/home/data' // 下拉查看更多接口
};
